import "./index.style.css";
import React, { useContext } from "react";
import { Select } from "antd";
import { LanguageContext } from "../../context/LanguageContext";

import th from "../../assets/language/lang-th.svg";
import en from "../../assets/language/lang-en.svg";

const LanguageSwitcher = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const handleChange = (value) => {
    setLanguage(value);
  };

  return (
    <div className="language-switcher">
      <Select value={language} onChange={handleChange} className="language-select">
        <Select.Option value="th">
          <div className="language-option">
            <img src={th} alt="Thai" className="flag-icon" />
            <span className="language-font">ไทย</span>
          </div>
        </Select.Option>
        <Select.Option value="en">
          <div className="language-option">
            <img src={en} alt="English" className="flag-icon" />
            <span className="language-font">English</span>
          </div>
        </Select.Option>
      </Select>
    </div>
  );
};

export default LanguageSwitcher;
